<template>
  <v-btn @click="$emit('click')" elevation="0" plain text>
    <v-icon> mdi-magnify </v-icon>
    <small class="text-caption ml-2" v-if="!isMobile">
      Suche <strong class="grey lighten-3 pa-1 rounded">⌘ + k</strong> oder
      <strong class="grey lighten-3 pa-1 rounded">strg + k</strong>
    </small>
  </v-btn>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import QuickLinkList from "./QuickLinkList.vue";

@Component({
  components: { QuickLinkList }
})
export default class QuickLinkMenu extends Vue {
  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }
}
</script>
